var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.801,
    height: 72.477,
    viewBox: "0 0 69.801 72.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(-368.678 -728.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1300_",
    transform: "translate(376 731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    d: "M86.39,26.093,81.919,21.62V12.757a5.438,5.438,0,0,0-5.432-5.432H67.634L60.712.4a1.359,1.359,0,0,0-.96-.4H54.693a1.358,1.358,0,0,0-.96.4L46.8,7.325H37.923a5.438,5.438,0,0,0-5.432,5.432v8.877l-4.468,4.458a6.949,6.949,0,0,0-2.05,4.947V62.524a6.969,6.969,0,0,0,1.966,4.854c.026.031.054.062.083.092s.06.056.091.082a6.969,6.969,0,0,0,4.855,1.966H51.095a1.358,1.358,0,0,0,0-2.716H32.968a4.251,4.251,0,0,1-1.908-.451L47.065,50.346l5.211,5.208A6.948,6.948,0,0,0,57.221,57.6h0a6.949,6.949,0,0,0,4.945-2.05l5.189-5.192L83.351,66.352a4.252,4.252,0,0,1-1.908.451H63.316a1.358,1.358,0,1,0,0,2.716H81.443A6.969,6.969,0,0,0,86.3,67.552c.031-.026.062-.053.092-.083s.057-.06.083-.092a6.969,6.969,0,0,0,1.966-4.854V31.037A6.95,6.95,0,0,0,86.39,26.093Zm-4.471-.631,2.55,2.551a4.312,4.312,0,0,1,.611.77L81.92,31.946ZM55.255,2.716h3.934l4.605,4.608H50.643Zm-25.313,25.3,2.549-2.543v6.471l-3.16-3.158A4.3,4.3,0,0,1,29.942,28.014Zm-.8,36.418a4.251,4.251,0,0,1-.45-1.908V31.981L45.144,48.426Zm31.108-10.8a4.251,4.251,0,0,1-3.025,1.254h0A4.251,4.251,0,0,1,54.2,53.633L35.207,34.655v-21.9a2.719,2.719,0,0,1,2.716-2.716H76.488A2.719,2.719,0,0,1,79.2,12.757v9.252a1.369,1.369,0,0,0,0,.325V34.663Zm25.474,8.893a4.251,4.251,0,0,1-.45,1.908L69.277,48.438,85.722,31.983Z",
    transform: "translate(-25.973 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    d: "M247.331,491.942a1.358,1.358,0,1,0,.96.4A1.368,1.368,0,0,0,247.331,491.942Z",
    transform: "translate(-216.099 -425.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    d: "M174.377,115.883A12.835,12.835,0,0,0,161.556,128.7a13.011,13.011,0,0,0,13,13h8.253a1.358,1.358,0,1,0,0-2.716h-8.253A10.292,10.292,0,0,1,164.272,128.7a10.105,10.105,0,0,1,20.211,0v2.783a1.94,1.94,0,0,1-3.879,0v-3.143a6.75,6.75,0,0,0-6.743-6.743,7.09,7.09,0,0,0,0,14.18h2.16a1.358,1.358,0,0,0,0-2.716h-2.16a4.374,4.374,0,0,1,0-8.748,4.031,4.031,0,0,1,4.027,4.027v3.143a4.656,4.656,0,0,0,9.311,0V128.7a12.836,12.836,0,0,0-12.821-12.821Z",
    transform: "translate(-143.145 -100.147)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6846",
    "data-name": "Path 6846",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(371.898 619.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6850",
    "data-name": "Path 6850",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(424.898 604.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6847",
    "data-name": "Path 6847",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(403.512 691.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6849",
    "data-name": "Path 6849",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(403.512 684.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6848",
    "data-name": "Path 6848",
    d: "M160.169,173.9v2.8h-2.8v-2.8Zm0,5.6v2.8h-2.8v-2.8Z",
    transform: "translate(211.309 593.954)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3ac84c20641781bd08f971d9dd4ec6f3.svg";
export { ForwardRef as ReactComponent };